import { PermissoesService } from './../../../service/usuario/permissoes.service';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {  TipoClienteModel } from 'app/model/cliente/tipocliente.model';
import { TipoclienteService } from 'app/service/cliente/tipocliente.service';
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';
import * as CryptoJS from 'crypto-js';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DialogTipoClienteComponent } from './dialog-tipo-cliente/dialog-tipo-cliente.component';


@Component({
  selector: 'app-tipocliente',
  templateUrl: './tipocliente.component.html',
  styleUrls: ['./tipocliente.component.scss']
})
export class TipoclienteComponent implements OnInit {

  msg: 'Teste';
  loading = true;

  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  private products: Array<TipoClienteModel> = []
  public page : ResponsePageable;

  @ViewChild('alert') alert: ElementRef;
  @ViewChild('cardAdd') targetEl : ElementRef;
  @ViewChild('tipoClienteInput') tipoClienteInput : ElementRef;

  public responsePageable: ResponsePageable;

  public submit = false;

  public alertSuccess = false;

  public tipoClienteForm: FormGroup;

  public tipoClienteFormEdit: FormGroup;

  public pageAtual = 0;

  tipoCliente = {} as TipoClienteModel;
  tipoClientes: TipoClienteModel[];

  @ViewChild('search') searchElement: ElementRef;

  show = false;
  name: string;

  public edited = false;
  public editado = false;
  public errorAlert = false;
  public successDelete = false;

  public arrayString: string;
  public createTipoCliente = false;
  public editorTipoCliente = false;
  public listaTipoCliente = false;
  public deletarTipoCliente = false;
  public superUser = false;

  constructor(
    private tipoClienteService: TipoclienteService,
    private fb: FormBuilder,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private permissionService: PermissoesService) { }

  ngOnInit() {
    this.listTipoCliente(0, 10);
    this.getAuthority();
  }

  listTipoCliente(page, size){
    this.tipoClienteService.getTipoClientes(page, size).subscribe(res => {
      this.page = res;
      this.tipoClientes = this.page.content;
      this.loading = false;
    });
  }

  listarTipoCliente(){
    this.tipoClienteService.getTipoClientes2().subscribe(data => {
      this.tipoClientes = data.content;
    })
  }

  changePage(event){
   this.listTipoCliente(event.page, event.size);
   this.pageAtual = event.page;
  }

  onSubmit(){
    this.submit = true;
  }

  showSearch(){
    this.show = !this.show;
    setTimeout(()=>{ // this will make the execution after the above boolean has changed
      this.searchElement.nativeElement.focus();
    },0);
  }

  postSubmit(){
    this.submit = false;
    this.tipoCliente.id = undefined;
    //this.alertSuccess = false;
    this.tipoClienteInput.nativeElement.value = '';
    this.tipoCliente.descricao = null;
  }

  scroll() {
    this.targetEl.nativeElement.scrollIntoView();
  }

  saveOrEdit() {
    if (this.tipoCliente.id !== undefined) {
      this.editTipoCliente();
    } else {
      this.cadastrarTipoCliente();
    }
  }

  cadastrarTipoCliente() {
    this.tipoClienteService.cadastrarTipoCliente(this.tipoCliente).subscribe(tipoCliente => {
        this.tipoCliente = new TipoClienteModel();
        this.listTipoCliente(0, 10);
        this.openSnackBarSuccess('Tipo de cliente salvo com sucesso !');
        this.postSubmit();
    } , err => {
      console.log(err);
      this.openSnackBarError('Erro ao adicionar Tipo de cliente');
    });
    }

  editTipoCliente() {
    this.tipoClienteService.atualizarTipoCliente(this.tipoCliente).subscribe(() => {
      this.tipoCliente = new TipoClienteModel();
      this.listTipoCliente(this.pageAtual, 10);
      this.openSnackBarSuccess('Tipo de cliente atualizado com sucesso !');
      this.postSubmit();
    }, err => {
      console.error(err);
      this.openSnackBarError('Erro ao atualizar o Tipo de cliente');
    });
  }

  putTipoCliente(tipoCliente: TipoClienteModel) {
    console.log(tipoCliente);
    this.tipoCliente = { ...tipoCliente};
  }

  confirmeExclusao(id: number){
    const confirme = confirm('Tem certeza que deseja excluir este tipo de cliente ?');
    if(confirme === true){
      this.deleteCliente(id);
    } else {
      console.log('Cancelou exclusão!');
    }
  }

  deleteCliente(id:number){
    this.tipoClienteService.deleteTipoCliente(id).subscribe(tipoCliente => {
        this.tipoCliente = new TipoClienteModel();
        this.listTipoCliente(0, 10);
        this.openSnackBarSuccess('Tipo de cliente excluído com sucesso!');
    }, err => {
      console.log('error', err);
      if(err.status === 500){
        this.openSnackBarError('Erro ao excluir! Este tipo de cliente está sendo usado por um cliente.');
      }
    });
  }

  getAuthority() {
    this.getItemAuthority('authority');
    if (this.arrayString.includes('ADD_EMPRESA')) {
      this.createTipoCliente = true;
    }
    if (this.arrayString.includes('EDIT_EMPRESA')) {
      this.editorTipoCliente = true;
    }
    if (this.arrayString.includes('LIST_EMPRESA')) {
      this.listaTipoCliente = true;
    }
    if (this.arrayString.includes('DELETE_EMPRESA')) {
      this.deletarTipoCliente = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          store,
          sessionStorage.getItem('ticket-ECM')
        );
        this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.arrayString;
      } catch (e) {
        sessionStorage.clear();
      }
    }

    return null;
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/cliente-components/tipocliente/tipocliente.component.ts